/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const PencilLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M15.73 9.58 14.3 8.16 5 17.48v1.41h1.41zm1.41-1.42 1.42-1.41-1.42-1.42-1.41 1.42zM7.24 20.9H3v-4.24L16.43 3.2a1 1 0 0 1 1.42 0l2.83 2.83a1 1 0 0 1 0 1.41z" />
  </Icon>
);
